import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBinoculars = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 221 221",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M121.349 173.838C156.458 167.644 179.898 134.161 173.704 99.0522C167.51 63.9433 134.027 40.5032 98.9183 46.6972C63.8095 52.8912 40.3694 86.3738 46.5634 121.483C52.7574 156.591 86.2399 180.032 121.349 173.838Z",
			fill: "#005BE4"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M124.059 189.405C167.879 181.674 197.136 139.883 189.405 96.0623C181.674 52.2417 139.883 22.9852 96.0624 30.7162C52.2417 38.4471 22.9853 80.238 30.7162 124.059C38.4472 167.879 80.238 197.136 124.059 189.405Z",
			fill: "#005BE4"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .1,
			d: "M126.566 203.616C178.235 194.5 212.731 145.224 203.616 93.5552C194.5 41.8861 145.224 7.38969 93.5552 16.5053C41.8861 25.6209 7.38966 74.8967 16.5053 126.566C25.6209 178.235 74.8966 212.731 126.566 203.616Z",
			fill: "#005BE4"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_3905_24573",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 45,
			y: 45,
			width: 130,
			height: 130,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M121.349 173.838C156.458 167.644 179.898 134.161 173.704 99.0522C167.51 63.9433 134.027 40.5032 98.9183 46.6972C63.8095 52.8912 40.3694 86.3738 46.5634 121.483C52.7574 156.591 86.2399 180.032 121.349 173.838Z",
				fill: "#005BE4"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_3905_24573)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M38.806 118.781L58.3748 111.589L64.5612 134.541L45.145 139.569C42.2086 140.087 36.0252 139.361 34.7819 132.314C33.5387 125.267 33.3803 121.341 38.806 118.781Z",
				fill: "#062897"
			})
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask1_3905_24573",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 77,
			y: 102,
			width: 29,
			height: 28,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M81.7106 109.723L100.124 102.955L105.945 124.552L87.6753 129.283C84.9124 129.771 79.094 129.088 77.9241 122.457C76.7542 115.826 76.6052 112.132 81.7106 109.723Z",
				fill: "#031F7C"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask1_3905_24573)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M101.005 95.2581L136.541 82.9555L150.823 121.159L115.975 128.816C110.755 130.574 99.3054 130.65 95.2678 116.883C91.2301 103.116 97.4102 96.7302 101.005 95.2581Z",
				fill: "#031552"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M103.222 94.8669L138.758 82.5644L153.04 120.768L118.192 128.424C112.972 130.183 101.522 130.259 97.4848 116.492C93.4472 102.725 99.6273 96.3391 103.222 94.8669Z",
			fill: "#062897"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask2_3905_24573",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 96,
			y: 82,
			width: 58,
			height: 48,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M103.222 94.8669L138.758 82.5644L153.04 120.768L118.192 128.424C112.972 130.183 101.522 130.259 97.4848 116.492C93.4472 102.725 99.6273 96.3391 103.222 94.8669Z",
				fill: "#031F7C"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask2_3905_24573)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M133.94 80.9007L152.583 72.5841L165.086 120.654L144.607 124.267C139.942 124.42 129.923 120.824 127.17 105.222C124.418 89.6193 130.537 82.5067 133.94 80.9007Z",
				fill: "#031552"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M137.841 80.2126L156.484 71.8959L168.986 119.966L148.508 123.579C143.843 123.732 133.823 120.136 131.071 104.534C128.318 88.9311 134.437 81.8185 137.841 80.2126Z",
			fill: "#052387"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 162.623,
			cy: 96.3596,
			rx: 13.6514,
			ry: 22.53,
			transform: "rotate(-13.725 162.623 96.3596)",
			fill: "#66A8FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M169.184 96.5278C166.131 99.8688 166.251 92.8503 163.278 88.3938C160.585 84.3585 155.821 84.3126 156.326 80.1336C156.831 75.9546 164.078 79.8922 167.292 83.9907C170.507 88.0893 172.238 93.1869 169.184 96.5278Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M156.367 111.132C168.958 116.954 176.043 100.119 175.183 95.2431L178.136 106.285L168.728 118.503L158.862 116.724L156.367 111.132Z",
			fill: "#3083F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M173.925 108.867C175.413 104.679 175.736 99.0606 174.275 93.0794C172.814 87.0982 169.938 82.2613 166.687 79.2302C163.404 76.1701 160.18 75.2853 157.628 75.9086C155.076 76.532 152.623 78.8032 151.121 83.032C149.632 87.2206 149.31 92.8387 150.771 98.8199C152.232 104.801 155.108 109.638 158.359 112.669C161.642 115.729 164.865 116.614 167.418 115.991C169.97 115.367 172.423 113.096 173.925 108.867ZM168.416 120.08C177.165 117.943 181.619 105.407 178.364 92.0807C175.109 78.7539 165.378 69.6827 156.629 71.8194C147.881 73.9562 143.427 86.4919 146.682 99.8186C149.937 113.145 159.667 122.217 168.416 120.08Z",
			fill: "#0030CF"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask3_3905_24573",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 34,
			y: 111,
			width: 31,
			height: 29,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M38.806 118.781L58.3748 111.589L64.5612 134.541L45.145 139.569C42.2086 140.087 36.0252 139.361 34.7819 132.314C33.5387 125.267 33.3803 121.341 38.806 118.781Z",
				fill: "#031F7C"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask3_3905_24573)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M59.311 103.409L97.0769 90.3347L112.254 130.935L75.2201 139.072C69.6726 140.941 57.5048 141.022 53.2138 126.391C48.9228 111.76 55.4907 104.974 59.311 103.409Z",
				fill: "#031552"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M61.667 102.993L99.4329 89.919L114.61 130.52L77.5762 138.656C72.0287 140.525 59.8609 140.606 55.5699 125.975C51.2789 111.345 57.8468 104.558 61.667 102.993Z",
			fill: "#062897"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask4_3905_24573",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 54,
			y: 89,
			width: 61,
			height: 51,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M61.667 102.993L99.4329 89.919L114.61 130.52L77.5762 138.656C72.0287 140.525 59.8609 140.606 55.5699 125.975C51.2789 111.345 57.8468 104.558 61.667 102.993Z",
				fill: "#031F7C"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask4_3905_24573)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M94.3124 88.1509L114.125 79.3125L127.412 130.398L105.649 134.238C100.691 134.4 90.0431 130.58 87.1178 113.998C84.1924 97.4165 90.6953 89.8577 94.3124 88.1509Z",
				fill: "#031552"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98.4578 87.4196L118.27 78.5812L131.558 129.667L109.794 133.507C104.836 133.669 94.1885 129.848 91.2632 113.267C88.3378 96.6852 94.8407 89.1263 98.4578 87.4196Z",
			fill: "#062897"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 124.795,
			cy: 104.58,
			rx: 14.5079,
			ry: 23.9435,
			transform: "rotate(-13.725 124.795 104.58)",
			fill: "#66A8FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M118.147 120.278C131.527 126.467 139.057 108.575 138.142 103.393L141.281 115.128L131.283 128.113L120.798 126.222L118.147 120.278Z",
			fill: "#3083F1"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M132.119 104.377C129.065 107.718 129.185 100.699 126.212 96.2426C123.52 92.2072 118.755 92.1613 119.26 87.9824C119.765 83.8034 127.012 87.7409 130.227 91.8395C133.441 95.938 135.173 101.036 132.119 104.377Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M137.055 117.961C138.656 113.454 138.997 107.43 137.434 101.031C135.871 94.6318 132.792 89.4436 129.293 86.1825C125.764 82.8924 122.25 81.8988 119.424 82.5891C116.597 83.2795 113.937 85.7809 112.322 90.3276C110.721 94.8341 110.38 100.858 111.943 107.257C113.506 113.656 116.585 118.845 120.083 122.106C123.613 125.396 127.126 126.389 129.953 125.699C132.78 125.009 135.439 122.507 137.055 117.961ZM130.952 129.788C140.249 127.517 144.982 114.195 141.523 100.032C138.064 85.8695 127.723 76.2291 118.425 78.4999C109.127 80.7708 104.394 94.0929 107.853 108.256C111.313 122.419 121.654 132.059 130.952 129.788Z",
			fill: "#0030CF"
		})
	]
});
export default SvgBinoculars;
